import { clients } from '../lib/https';
import { useModelStore } from '../state/store/chat/use-model-store';
import { Atom } from 'lucide-react';
import { ModelTypes } from 'features/chat/types/model.types';
import { ConfigurationSettings } from '/models/configuration-settings';

export interface ILlmModelGetDTO {
  itemId: string;
  modelName: string;
  modelDisplayName: string;
  modelDescription: string;
  modelType: string;
  isActive: boolean;
  isThinkingModel: boolean;
  isDefaultModel: boolean;
  order: number;
}

export const getLlmModels = async (config: ConfigurationSettings): Promise<ILlmModelGetDTO[]> => {
  const baseUrl = `https://${config.paths.baseUrl}`;
  const url = `${baseUrl}${config.paths.bebrave.modelConfigurationGets}?projectkey=${config.blocksKey}`;
  const models = await clients.get<ILlmModelGetDTO[]>(url, config.blocksKey);
  if (models) {
    const mappedModel = models
      .filter((model) => model.isActive)
      .sort((a, b) => a.order - b.order)
      .map((model) => {
        const icon = <Atom size={12} className="text-gray-600" />;

        return {
          id: model.modelName,
          name: model.modelDisplayName,
          description: model.modelDescription,
          modelType: model.modelType === 'NonVision' ? ModelTypes.NO_VISION : ModelTypes.VISION,
          isThinkingModel: model.isThinkingModel,
          icon: icon,
          isDefaultModel: model.isDefaultModel,
          order: model.order,
        };
      });
    useModelStore.getState().setModels(mappedModel);
  }
  return models;
};
